import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { getTimesheetEntriesQueryKey } from '../timesheet-entry/query-key';
import { invalidateTimesheetRowsQuery } from '../timesheet-row/query';
import { invalidateTimesheetQuery, setTimesheetQueryData } from './query';
export function usePostTimesheetSaveSettled() {
    const queryClient = useQueryClient();
    return useCallback((timesheetId) => {
        setTimesheetQueryData(queryClient, timesheetId, (draft) => {
            draft.saveState = 'NOT_SAVING';
            return draft;
        });
        // This is currently used so that, if you `print` on a fresh timesheet, it will refetch the timesheet to get the recordNo.
        invalidateTimesheetQuery(queryClient, timesheetId);
        invalidateTimesheetRowsQuery(queryClient, timesheetId);
        queryClient.invalidateQueries({
            queryKey: getTimesheetEntriesQueryKey(timesheetId),
        });
    }, [queryClient]);
}
//# sourceMappingURL=use-post-timesheet-save-settled.js.map